import { withNaming } from '@bem-react/classname';
import { classnames } from '@bem-react/classnames';

const cn = withNaming({ e: '__', m: '_', v: '_' });

export function mixHoverOpacity(className: string) {
    return classnames('hover-opacity', className);
}

export default cn;
